// import {fade, makeStyles} from '@material-ui/core/styles'
import {blueColor, grayColor} from '../../cmsMainStyle'

const filemanagerToolbarStyle = theme => ({
	root: {
		flexGrow: 1,
		display: 'flex',
		alignItems: 'center',
		minHeight: 50,
		borderBottom: "1px solid " + grayColor[4],
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},

	highlight: {
		backgroundColor: blueColor[2]
	},

	title: {
		flexGrow: 1,
	},

	toolBar: {
		display: "flex",
		flexDirection: "row",
		alignItems: 'center',
	},

	searchBar: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative',
		width: '100%',
		height: 35,
		backgroundColor: grayColor[0],
		marginLeft: 0,
		borderRadius: theme.shape.borderRadius,

		'&:hover': {
			backgroundColor: grayColor[0],
		},

		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(1),
			width: 'auto',
		},
	},

	searchIcon: {
		display: 'flex',
		alignItems: 'center',
		position: 'absolute',
		pointerEvents: 'none',
		padding: theme.spacing(0, 2),
	},

	downIcon: {
		display: 'flex',
		alignItems: 'center',
		padding: theme.spacing(0, 1),
	},

	inputRoot: {
		color: 'inherit',
	},

	inputInput: {
		width: '100%',
		fontSize: 15,
		transition: theme.transitions.create('width'),
		padding: theme.spacing(1, 1, 1, 0),
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,

		[theme.breakpoints.up('sm')]: {
			width: '15ch',
			'&:focus': {
			width: '50ch',
			},
		},
	},

})


export default filemanagerToolbarStyle